<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template v-slot:item.timeZone="{ item }">
      {{ getTimezoneTitle(item.timeZone) }}
    </template>
  </entity-list-table>
</template>

<script>

  import RegionDataService from '@/services/api/RegionDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import { mapGetters } from 'vuex'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Регионы',
        dataService: RegionDataService,
        createRouteName: 'regionCreate',
        editRouteName: 'regionEdit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Название в падеже', value: 'namePadeg', align: 'start' },
          { text: 'Часовой пояс', value: 'timeZone', align: 'start' },
          { text: 'Поддомен', value: 'slug', align: 'start' },
          { text: 'Телефон', value: 'phone', align: 'start' },
          { text: 'Режим работы', value: 'workTimeString', align: 'start' },
          { text: 'Радиус зоны (км)', value: 'zoneRadius', align: 'start' },
          // { text: 'Основной', value: 'isMain', align: 'center', type: 'boolean-check' },
        ],

        allowDelete: false,
        showStatusColumn: true,
      }
    },
    computed: {
      ...mapGetters({
        getTimezoneTitle: 'app/getTimezoneTitle',
      }),
    },
  }
</script>
